import { createI18n } from 'vue-i18n';
import { FALLBACK_LOCALE, messages } from '../locales';

/**
 * Create a configured vue-i18n instance.
 *
 * @param {string} locale - Initial locale for the application.
 * @returns {ReturnType<typeof createI18n>}
 */
export function createI18nInstance(locale) {
  return createI18n({
    legacy: false,
    globalInjection: true,
    locale,
    fallbackLocale: FALLBACK_LOCALE,
    messages
  });
}
